var _g, _path, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchWithBgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 43,
    viewBox: "0 0 47 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7744_49134)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ECF1F7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2 23.8L29.7 28.3C30.1 28.7 30.1 29.3 29.7 29.7C29.5 29.9 29.2 30 29 30C28.8 30 28.5 29.9 28.3 29.7L23.8 25.2C22.3 26.3 20.5 27 18.5 27C13.8 27 10 23.2 10 18.5C10 13.8 13.8 10 18.5 10C23.2 10 27 13.8 27 18.5C27 20.5 26.3 22.4 25.2 23.8ZM18.5 12C14.9 12 12 14.9 12 18.5C12 22.1 14.9 25 18.5 25C20.3 25 21.9 24.3 23.1 23.1C24.3 21.9 25 20.3 25 18.5C25 14.9 22.1 12 18.5 12Z",
    fill: "#212529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7744_49134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2 23.8L29.7 28.3C30.1 28.7 30.1 29.3 29.7 29.7C29.5 29.9 29.2 30 29 30C28.8 30 28.5 29.9 28.3 29.7L23.8 25.2C22.3 26.3 20.5 27 18.5 27C13.8 27 10 23.2 10 18.5C10 13.8 13.8 10 18.5 10C23.2 10 27 13.8 27 18.5C27 20.5 26.3 22.4 25.2 23.8ZM18.5 12C14.9 12 12 14.9 12 18.5C12 22.1 14.9 25 18.5 25C20.3 25 21.9 24.3 23.1 23.1C24.3 21.9 25 20.3 25 18.5C25 14.9 22.1 12 18.5 12Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7744_49134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8H32V32H8V8Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7744_49134",
    x: 0,
    y: 0,
    width: 47,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784253 0 0 0 0 0.894808 0 0 0 0 0.945833 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7744_49134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7744_49134",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWithBgIcon);
export default __webpack_public_path__ + "static/media/SearchWithBgIcon.fbb5886c3d65f9ccb07ff1864999dc4b.svg";
export { ForwardRef as ReactComponent };